import { createTracker } from 'usage-tracker';
import events from 'asset-actions-lib/events.yaml';
export const UsageTracker = createTracker({
  events,
  properties: {
    namespace: 'asset-actions-lib'
  }
});